import React from 'react';
import Logo1 from '../../../assets/TimeLineLogo/Logo1.svg';
import Logo2 from '../../../assets/TimeLineLogo/Logo2.svg';
import Logo3 from '../../../assets/TimeLineLogo/Logo3.svg';
import Logo4 from '../../../assets/TimeLineLogo/Logo4.svg';
import timeLineImage from '../../../assets/Images/TimelineImage.png';

const timeLine = [
    {
        Logo: Logo1,
        Heading: "Leadership",
        Description: 'Fully committed to the success company'
    },
    {
        Logo: Logo2,
        Heading: "Responsibility",
        Description: 'Students will always be our top priority'
    },
    {
        Logo: Logo3,
        Heading: "Flexibility",
        Description: 'The ability to switch is an important skill'
    },
    {
        Logo: Logo4,
        Heading: "Solve the problem",
        Description: 'Code your way to the solution'
    },
];

const TimeLineSectoin = () => {
    return (
        <div>
            <div className='flex lg:flex-row flex-col gap-14 items-center w-11/12 max-w-maxContent mx-auto justify-between lg:pb-32 relative lg:top-0 -top-36'>
                <div className='flex flex-col gap-5 items-center justify-evenly'>
                    {timeLine.map((element, index) => {
                        return (
                            <div className='flex flex-row w-full -my-2' key={index}>
                                <div className='flex flex-col items-center'>
                                    <div className='w-[50px] h-[50px] bg-white flex items-center justify-center rounded-full'>
                                        <img
                                            src={element.Logo}
                                            alt='logo'
                                            loading='lazy'
                                        />
                                    </div>
                                    {index !== 3 ? <div className='mt-2 mb-1 h-[2.5rem] border-r-4 border-richblack-100 border-opacity-50 border-dashed' /> : ''}
                                </div>
                                <div>
                                    <h2 className='font-semibold tet-[18px]'>{element.Heading}</h2>
                                    <p className='text-base'>{element.Description}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className=' w-fit h-fit shadow-blue-200 shadow-[0px_0px_40px_0px]'>
                    <div className='relative flex h-full items-center'>
                        <img
                            src={timeLineImage}
                            alt='timeLineImage'
                            loading='lazy'
                            className='md:shadow-[20px_20px_rgba(255,255,255)] shadow-[10px_10px_rgba(255,255,255)] object-cover w-[40rem]' />
                        <div className='absolute bg-caribbeangreen-700 justify-center items-center flex md:flex-row flex-col text-white uppercase md:py-8 md:px-24 md:-bottom-10 md:left-[6%] experiance-strip-medium-devices'>
                            <div className='flex flex-row md:gap-7 gap-5 md:pb-0 pb-2 items-center justify-center md:border-r-2 md:border-b-0 border-b-2 border-caribbeangreen-300 md:pr-10 md:mr-10'>
                                <p className='md:text-3xl text-lg font-bold'>10</p>
                                <span className='text-caribbeangreen-300 md:text-sm text-[10px]'>Years of <br />Experience</span>
                            </div>
                            <div className='flex flex-row gap-5 items-center justify-center md:mt-0 mt-2'>
                                <p className='md:text-3xl text-lg font-bold'>250</p>
                                <span className='text-caribbeangreen-300 md:text-sm text-[10px]'>Types of <br />courses</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeLineSectoin;